import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { receiptServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}


const receiptInstance = axios.create({
  baseURL: receiptServiceUrl,
  headers,
})

receiptInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

receiptInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default receiptInstance
